import React, { useEffect, useState } from "react";
import { Flex, Box, Image } from "rebass";
import { theme } from "../utils/theme";
import { LoginLayout } from "../layouts/LoginLayout";
import { Label, Input } from "@rebass/forms";
import { useForm } from "react-hook-form";
import { MainButton } from "../components/MainButton/MainButton";
import { userActions } from "../logic/actions";
import { useSelector, useDispatch } from "react-redux";
import logoImage from "../static/images/hernoLogo.png";
import loginImage from "../static/images/loginImage.webp";

const ResetPasswordPage = () => {
  const dispatch = useDispatch();

  const { register, handleSubmit, errors } = useForm();
  const authError = useSelector((state) => state.authentication.error);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(userActions.logout());
  }, []);

  useEffect(() => {
    if (authError) {
      if (authError.message) {
        setError(authError.message);
      } else {
        setError(authError);
      }
    }
  }, [authError]);

  const onSubmit = (data) => {
    dispatch(userActions.login(data.email, data.password));
  };

  const renderLeft = () => {
    return (
      <Flex
        width={1}
        flexGrow={1}
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        overflow={"hidden"}
        style={{
          background: "url(" + loginImage + ")",
          backgroundSize: "cover",
        }}
      ></Flex>
    );
  };

  const renderForm = () => {
    return (
      <Flex flexDirection="column" flexGrow={1}>
        <Flex flexGrow={1} justifyContent="center" alignItems="center" p={4}>
          <Box width={1} as="form" onSubmit={handleSubmit(onSubmit)}>
            <Box
              width={1}
              fontSize={theme.textBig}
              fontWeight={800}
              color={theme.black}
              mb={3}
            >
              <Image src={logoImage} maxHeight={60}></Image>
            </Box>

            <Box style={{ marginBottom: 20 }}>
              <Label py={1} htmlFor="email" style={{ color: theme.white }}>
                Username or Email Address
              </Label>
              <Input
                style={{
                  color: theme.white,
                  border: "1px solid #fff",
                }}
                id="email"
                name="email"
                type="email"
                ref={register({ required: true })}
                placeholder="john.doe@mail-bip.com"
              />
              {errors.email && <span>This field is required</span>}
            </Box>

            <Box style={{ marginBottom: 40 }}>
              <Flex justifyContent="space-between" py={1} w={1}>
                <Label htmlFor="password" style={{ color: theme.white }}>
                  Password
                </Label>
                <Label
                  justifyContent="flex-end"
                  htmlFor="password"
                  style={{ color: theme.white }}
                >
                  Forgot Password?
                </Label>
              </Flex>
              <Input
                style={{
                  color: theme.white,
                  border: "1px solid #fff",
                }}
                id="password"
                name="password"
                type="password"
                ref={register({ required: true })}
                placeholder="your password"
              />
              {errors.password && <span>This field is required</span>}
            </Box>

            <MainButton type="primary" label="Sign In" sx={{ width: 100 }} />
          </Box>
        </Flex>
      </Flex>
    );
  };

  return (
    <LoginLayout
      error={error}
      leftContent={renderLeft()}
      formContent={renderForm()}
    />
  );
};

export { ResetPasswordPage };
